import Constants from '../Constants';

export default {
  intervalDuration(state) {
    let duration = state.settings.intervalDurationValue,
        unitId = state.settings.intervalDurationUnitId;
    if (!duration || !unitId) {
      return null;
    }
    duration = parseInt(duration);
    unitId = parseInt(unitId);
    if (unitId === Constants.INTERVAL_DURATION_UNIT_MINUTES) {
      return duration * 60;
    } else {
      return duration;
    }
  },
  shouldSessionBeSaved(state) {
    return !!state.intervals.length;
  },

  saveSessionData(state, getters, rootState) {
    return {
      assigneeId: rootState.route.params.clientId,
      uuid: state.uuid,
      startedAt: state.startedAt,
      finishedAt: state.finishedAt,
      intervals: state.intervals,
      report: {
        behaviourTypeId: parseInt(state.settings.behaviourTypeId),
        aimTypeId: parseInt(state.settings.aimTypeId),
        intervalDurationValue: parseInt(state.settings.intervalDurationValue),
        intervalDurationUnitId: parseInt(state.settings.intervalDurationUnitId),
        behaviourDescription: state.settings.behaviourDescription || null,
      },
    };
  },
  isIntervalStarted(state) {
    let interval = state.currentInterval;
    return (interval.current < interval.duration) &&
        (interval.behaviourHappenedAt === null);
  },
};


// WEBPACK FOOTER //
// ./src/modules/dro/vuex/getters.js